import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';

import App from './components/App';
import TelemetryProvider from './components/TelemetryProvider';
import { environment } from './environment';
import { AuthService } from './services';
import { isDarkTheme, loadDarkTheme, loadLightTheme } from './theme';
import initMockedServer from './mockedData';

import './index.scss';
import { initializeIcons, ThemeProvider } from '@fluentui/react';

// Create browser history to use in the Redux store
const rootElement = document.getElementById('root');
const authService = new AuthService();

if (process.env.NODE_ENV === 'development' && authService.getAccount() !== null && JSON.parse(environment.useMock)) {
  initMockedServer();
}

function renderReact(): void {
  if (isDarkTheme()) {
    loadDarkTheme();
  } else {
    loadLightTheme();
  }

  initializeIcons();
  ReactDOM.render(
    <HashRouter>
      <TelemetryProvider instrumentationKey={environment.appInsightsKey}>
        <ThemeProvider className="app h-100">
          <App />
        </ThemeProvider>
      </TelemetryProvider>
    </HashRouter>,
    rootElement
  );
}

if (authService.getAccount() === null) {
  // Force a login if a User has not authenticated
  authService.login();
} else {
  renderReact();
}
